import messageHandler from './messages';

export default code => {
  // TODO: undefined code
  const message = messageHandler();
  return message[code];
};
